import React, { Fragment,useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom'
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import icon1 from '../../images/whatsapp.svg';
import icon2 from '../../images/check-mark.png';
const Thankyou = (props) => {

    return (
        <Fragment>
            <Header />
            <main className="page_content about-page">
                <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <h2>Thank You for Your Enquiry</h2>
                                    <p>We will contact you soon</p>
                                    <img src={icon2} alt="Check Mark" style={{width:'100px',height:'100px',marginLeft:'auto',marginRight:'auto',display:'block'}} />
                                    <a href="https://wa.me/918299406767" style={{backgroundColor:'rgb(101 216 68)',textDecoration:'none',border:'none'}} className="btn btn-primary mt-3 p-3"><img src={icon1} alt="WhatsApp" style={{width:'27px',height:'27px'}} />Message Us On WhatsApp</a>
                                </div>
                            </div>
                        </div>
                </section>
            
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default Thankyou;